import {
  POST_CANCEL_HAND,
  POST_PRE_INVESTIGATE,
  POST_PRE_INVESTIGATE_CANCEL_HAND,
} from "../../../API/apiUrls";

// constants.js
export const OPTIONS_TIME = [
  { value: 0, label: "ทั้งหมด" },
  { value: 30, label: "เคยสืบแล้วเมื่อ 1 เดือน" },
  { value: 90, label: "เคยสืบแล้วเมื่อ 3 เดือน" },
  { value: 120, label: "เคยสืบแล้วเมื่อ 4 เดือน" },
  { value: 180, label: "เคยสืบแล้วเมื่อ 6 เดือน" },
];

export const OPTIONS_TYPE = [
  { label: "จำนอง สัญญา 1", value: "lsfhp" },
  { label: "เช่าซื้อบัญชี 2", value: "vsfhp" },
  { label: "เช่าซื้อบัญชี 8", value: "sfhp" },
  { label: "P-LOAN", value: "rpsl" },
  { label: "3(เก่า)", value: "psfhp" },
];

export const OPTIONS_TYPE_KSM = [
  { label: "SmartVAT", value: "vsfhp" },
  { label: "SmartHP", value: "tsfhp" },
  { label: "SmartLoan (ที่ดิน)", value: "lsfhp" },
  { label: "P-LOAN", value: "rpsl" },
];

export const OPTIONS_STATUS = [
  { value: 0, label: "ยังไม่เคยสืบทรัพย์" },
  { value: 1, label: "แจ้งธรุการส่งสืบทรัพย์" },
  { value: 2, label: "ดำเนินการส่งสืบทรัพย์" },
  { value: 3, label: "เจอทรัพย์" },
  { value: 4, label: "ไม่เจอทรัพย์" },
];

export const OPTION_CONTRACT_PERIOD = [
  { value: "120", label: "ยอดน้อยกว่า 20% ขาดติดต่อ 120 วัน " },
  {
    value: "180",
    label: "เกรด D ขึ้นไป ยอดมากกว่า 20% ขาดติดต่อ 180 วัน ",
  },
  { value: "240", label: "เกรด D ขึ้นไป ขาดติดต่อ 240 วัน " },
];

export const OPTION_CONTRACT_PERIOD_KSM = [
  { value: 8, label: "ค้างงวดเกิน 8 งวด " },
  {
    value: 12,
    label: "ค้างงวดเกิน 12 งวด ",
  },
];

export const BASE_OPTIONS = [
  { value: 0, label: "ทั้งหมด" },
  { value: 1, label: "พร้อมฟ้อง" },
  { value: 2, label: "เจอทรัพย์" },
  { value: 3, label: "ไม่เจอทรัพย์" },
  { value: 4, label: "ออกบอกเลิกแล้ว" },
  { value: 5, label: "ไม่มีบอกเลิก" },
  { value: 8, label: "ตอบกลับบางส่วน" },
  { value: 9, label: "ตอบกลับครบ" },
  { value: 6, label: "ยังไม่สืบ" },
  { value: 7, label: "ดำเนินการส่งสืบทรัพย์" },
  { value: 10, label: "แจ้งธรุการส่งสืบทรัพย์" },
];

export const EXCLUSIONS = {
  1: [0, 4, 5, 6, 7, 8],
  2: [6, 7],
  4: [5],
  5: [4, 1, 8, 9],
  6: [7, 2, 1],
  7: [6, 2, 1],
  8: [9, 5, 4],
  9: [8, 5, 4],
};

export const BTN_TO_API = {
  1: POST_PRE_INVESTIGATE,
  2: POST_CANCEL_HAND,
  3: POST_PRE_INVESTIGATE_CANCEL_HAND,
};

export const STATUS_PROCESS = [
  { value: 0, label: "ยังไม่ส่งฟ้อง" },
  { value: 1, label: "ธรุการเตรียมสัญญา" },
  { value: 2, label: "เบลจัดเตรียมเอกสารฟ้อง" },
  { value: 3, label: "รอทนายรับงาน" },
  { value: 4, label: "รอวันนัดศาล" },
  { value: 5, label: "รอพิพากษา" },
  { value: 6, label: "เอกสารไม่ครบ" },
  { value: 7, label: "ทนายรับงาน" },
  { value: 8, label: "ถอนฟ้อง" },
  { value: 9, label: "พิพากษา" },
  { value: 10, label: "ทำยอม" },
  { value: 11, label: "รอวางคำบังคับ" },
  { value: 12, label: "คดีถึงที่สุด" },
  { value: 13, label: "อุธรณ์" },
  { value: 14, label: "ปิดบัญชี" },
];
